/**
 * @module actions/discountsAndKickback
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Get assessment discounts/kickbacks
 * @return {Promise} Axios promise
 */
export function getAssessmentCustomerRates (customerId = 0, usage = 0) {
  let url = API_URL + '/DiscountsAndKickback/Assessment/Customer/Get/' + customerId + '?usage=' + usage
  // if (customerId !== undefined && customerId > 0) url += '?CustomerId=' + customerId + '&usage=' + usage
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Update assessment discounts/kickbacks
 * @return {Promise} Axios promise
 */
export function updateAssessmentCustomerRates (data) {
  let url = API_URL + '/DiscountsAndKickback/Assessment/Customer/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/discountsAndKickback.js